<template>
  <div class="navbar">
    <div class="navbar-inner">
      <div class="left-menu">
        <div class="toggle-btn" @click="changeIsCollapse(!getIsOpenCloseManu)">
          <i :class="getIsOpenCloseManu ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>

        <el-breadcrumb separator-class="el-icon-arrow-right" class="custom-breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">
            <span class="home-text">Trang chủ</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item
              v-for="(item, index) in getBreadcrumbDataList"
              :key="index"
              :to="{ path: item.url }"
              @click.native="handleBreadcrumbClick(item)"
          >
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="right-menu">
        <span
            v-if="
            getAppTypeUserLogin === appType.SUPPER_SCHOOL ||
            getAppTypeUserLogin === appType.SCHOOL ||
            getAppTypeUserLogin === appType.TEACHER ||
            getAppTypeUserLogin === appType.PARENT
          "
            class="school-name"
        >{{ getDataSchool.schoolName }}</span
        >
        <div class="vertical-divider"></div>
<!--        <div class="action-icons">-->
<!--          <NotificationNavbar v-if="getAppTypeUserLogin === appType.SCHOOL"/>-->
<!--        </div>-->
        <el-popover
            v-model="showUserMenu"
            placement="bottom-end"
            trigger="click"
            popper-class="premium-user-popper"
            :visible-arrow="false"
            width="300"
        >
          <div class="user-card">
            <div class="user-card-header">
              <div class="avatar-big-wrapper">
                <el-image class="avatar-big" :src="getAvatar"></el-image>
                <div class="status-indicator"></div>
              </div>
              <h3 class="user-name-display">{{ getUserLogin }}</h3>
              <p class="user-role-display">{{ getDataSchool.schoolName || 'Thành viên' }}</p>
            </div>
            <div class="user-card-body">
              <div class="menu-item-group" @click="handleDropdow('profileCommand')">
                <div class="icon-box blue-gradient">
                  <i class="el-icon-user-solid"></i>
                </div>
                <div class="menu-text">
                  <span class="main-title">Thông tin & tài khoản</span>
                  <span class="sub-title">Cập nhật hồ sơ cá nhân</span>
                </div>
                <i class="el-icon-arrow-right arrow-next"></i>
              </div>

              <div class="menu-item-group" @click="handleDropdow('changePasswordCommand')">
                <div class="icon-box orange-gradient">
                  <i class="el-icon-lock"></i>
                </div>
                <div class="menu-text">
                  <span class="main-title">Đổi mật khẩu</span>
                  <span class="sub-title">Bảo mật tài khoản của bạn</span>
                </div>
                <i class="el-icon-arrow-right arrow-next"></i>
              </div>

<!--              <div class="menu-item-group">-->
<!--                <div class="icon-box purple-gradient">-->
<!--                  <i class="el-icon-question"></i>-->
<!--                </div>-->
<!--                <div class="menu-text">-->
<!--                  <span class="main-title">Hỏi & Đáp</span>-->
<!--                  <span class="sub-title">Trung tâm hỗ trợ</span>-->
<!--                </div>-->
<!--                <i class="el-icon-arrow-right arrow-next"></i>-->
<!--              </div>-->
            </div>
            <div class="user-card-footer">
              <button
                  v-if="
                  (getDataSchool != null && getDataSchool.manyStatus && getAppTypeUserLogin === appType.SUPPER_SCHOOL) ||
                  getAppTypeUserLogin === appType.SCHOOL ||
                  getAppTypeUserLogin === appType.TEACHER ||
                  getAppTypeUserLogin === appType.PARENT
    "
                  class="btn-flat primary"
                  @click="handleDropdow('changeSchoolCommand')"
              >
                <i :class="getAppTypeUserLogin === appType.PARENT ? 'el-icon-user' : 'el-icon-office-building'"></i>
                <span>{{ getAppTypeUserLogin === appType.PARENT ? 'Chọn con' : 'Đổi trường' }}</span>
              </button>

              <button class="btn-flat danger" @click="logoutDeviceMethod('logoutCommand')">
                <i class="el-icon-switch-button"></i> Đăng xuất
              </button>
            </div>
          </div>

          <template #reference>
            <div class="profile-trigger" :class="{ 'active': showUserMenu }">
              <div class="avatar-mini-box">
                <el-image :src="getAvatar" class="avatar-mini"></el-image>
              </div>
              <span class="username-text">{{ getUserLogin }}</span>
              <i class="el-icon-arrow-down caret-icon"></i>
            </div>
          </template>
        </el-popover>
      </div>
    </div>

    <ChangePassword :dialogVisible="showCreateDialog" @dialog-close="dialogCloseCreateMethod()"/>
    <Profile :dialogVisible="showProfileDialog" @dialog-close="dialogCloseProfileMethod()" ref="Profile"/>
    <ChangeSchool :dialogVisible="showChangeSchoolDialog" @dialog-close="dialogCloseChangeSchoolMethod()" ref="ChangeSchool"/>
    <ChangeKidsDialog :dialogVisible="showChangeKidsDialog" @dialog-close="dialogCloseChangeKidsMethod()" ref="ChangeKidsDialog"/>
  </div>
</template>

<script>
import DeviceService from "@/services/DeviceService";
import ChangePassword from "@/views/login/ChangePassword.vue";
import Profile from "@/views/mauser/Profile.vue";
import ChangeSchool from "@/views/mauser/ChangeSchool.vue";
import ChangeKidsDialog from "@/views/mauser/ChangeKidsDialog.vue";
import NotificationNavbar from "@/layout/components/NotificationNavbar.vue";

export default {
  components: {
    ChangePassword,
    Profile,
    ChangeSchool,
    ChangeKidsDialog,
    NotificationNavbar,
  },
  data() {
    return {
      openClose: "",
      showCreateDialog: false,
      showProfileDialog: false,
      showChangeSchoolDialog: false,
      showChangeKidsDialog: false,
      appType: {
        SUPPER_SYSTEM: "supperSys",
        SYSTEM: "sys",
        AGENT: "agent",
        SUPPER_SCHOOL: "supperPlus",
        SCHOOL: "plus",
        TEACHER: "teacher",
        PARENT: "parent",
      },
      dataNotification: {
        total: null,
        dataNotificationList: [],
      }
    };
  },

  computed: {
    getBreadcrumbDataList() {
      let breadcrumbSession = JSON.parse(sessionStorage.getItem("breadcrumbList"));
      let breadcrumbState = this.$store.getters["layout/getBreadcrumbList"];
      if (breadcrumbState.length == 0) {
        return breadcrumbSession;
      } else {
        return breadcrumbState;
      }
    },
    getIsOpenCloseManu() {
      return this.$store.getters["layout/getIsOpenClose"];
    },
    getUserLogin() {
      return this.$store.state.auth.user.currentUser;
    },
    getAvatar() {
      return this.$store.state.auth.user.avatar;
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    getDataSchool() {
      return this.$store.state.auth.user.schoolInfor;
    },
  },
  methods: {
    // handleBreadcrumbClick(item) {
    //   // Nếu URL của item trùng với URL hiện tại của trình duyệt
    //   if (this.$route.path === item.url) {
    //     // Cách 1: Tải lại toàn bộ trang (F5 thực thụ)
    //     location.reload();
    //
    //     // Cách 2: Nếu bạn chỉ muốn load lại dữ liệu mà không muốn màn hình bị trắng (nháy trang)
    //     // thì nên gọi hàm fetch dữ liệu của trang đó thay vì reload.
    //   }
    // },
    handleBreadcrumbClick(item) {
      this.$router.push({
        path: item.url,
        query: { t: Date.now() } // Tạo tham số thời gian để ép router render lại
      });
    },
    changeIsCollapse(data) {
      this.$store.dispatch("layout/setIsOpenCloseMenu", data);
    },

    async logoutDeviceMethod() {
      let deviceData = { idDevice: "" };
      deviceData.idDevice = this.$browserDetect.full.ua || window.navigator.userAgent; // Fallback nếu full.ua không tồn tại
      await DeviceService.deviceLogout(deviceData)
          .then((resp) => {
            console.log(resp.data.data);
          })
          .catch((err) => {
            console.log(err);
          }).finally(() => {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
            this.$store.dispatch("notificationNavbarStore/resetData");
          });
    },
    handleDropdow(command) {
      if (command === "profileCommand") {
        this.profileDialog();
      } else if (command === "changePasswordCommand") {
        this.changePasswordDialog();
      } else if (command === "changeSchoolCommand") {
        if (this.getAppTypeUserLogin === this.appType.PARENT) {
          this.changeKidsDialog();
        } else {
          this.changeSchoolDialog();
        }
      }
    },
    changePasswordDialog() {
      this.showCreateDialog = true;
      // this.$refs.CreateGrade.resetFormData();
    },
    profileDialog() {
      this.showProfileDialog = true;
      this.$refs.Profile.getInitialData();
    },
    changeSchoolDialog() {
      this.showChangeSchoolDialog = true;
      this.$refs.ChangeSchool.getChangeSchoolInitialData();
    },
    changeKidsDialog() {
      this.showChangeKidsDialog = true;
      this.$refs.ChangeKidsDialog.getChangeKidsInitialData();
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },
    dialogCloseProfileMethod() {
      this.showProfileDialog = false;
    },
    dialogCloseChangeSchoolMethod() {
      this.showChangeSchoolDialog = false;
    },
    dialogCloseChangeKidsMethod() {
      this.showChangeKidsDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.navbar {
  height: 65px;
  background: #ffffff;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  border-bottom: 1px solid #f0f2f5;

  .navbar-inner {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.left-menu {
  display: flex;
  align-items: center;
  gap: 20px;

  .toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #f5f7fa;
    color: #5c6a82;
    cursor: pointer;
    transition: all 0.3s;
    &:hover { background: #edf2f9; color: #409eff; }
    i { font-size: 20px; }
  }
}
/deep/.noti-trigger .bell-icon {
  font-size: 25px;
  color: #6a7ea8;
  transition: color 0.2s;
}
.right-menu {
  display: flex;
  align-items: center;

  .action-icons {
    margin-right: 20px;
    display: flex;
    gap: 15px;
    color: #64748b;
      font-size: 18px;
    .search-icon { cursor: pointer; &:hover { color: #409eff; } }
  }
  .vertical-divider {
    width: 1px;
    height: 24px;
    background: #e2e8f0;
    margin: 0 20px;
  }
}

.profile-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;

  &:hover, &.active {
    background: #f8fafc;
    border-color: #e2e8f0;
  }

  .avatar-mini-box {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  .username-text {
    font-weight: 600;
    color: #334155;
    font-size: 16px;
  }

  .caret-icon {
    font-size: 12px;
    color: #94a3b8;
    transition: transform 0.3s;
  }
  &.active .caret-icon { transform: rotate(180deg); }
}
.left-menu {
  display: flex;
  align-items: center;
  gap: 20px;

  /* Tinh chỉnh Breadcrumb */
  .custom-breadcrumb {
    /deep/ .el-breadcrumb__item {
      /* Chỉnh cỡ chữ cho các item con (Tên menu hiện tại) */
      font-size: 16px;
      font-weight: 500;

      .el-breadcrumb__inner {
        cursor: pointer !important;
        color: #606266;
        &.is-link:hover {
          color: #409eff;
        }
        &:hover {
          color: #409eff !important;
          font-weight: 600;
        }
      }
    }

    /* Chỉnh riêng cho chữ Trang chủ */
    .home-text {
      font-size: 17px; /* To hơn các item sau một chút để tạo điểm nhấn */
      font-weight: 600; /* Đậm hơn để rõ nét */
      color: #303133;  /* Màu tối hơn để sắc nét */
    }

    /* Chỉnh cỡ icon mũi tên phân cách giữa các cấp menu */
    /deep/ .el-breadcrumb__separator {
      font-size: 14px;
      font-weight: bold;
      color: #c0c4cc;
    }
  }
}
/* POPOVER STYLE */
</style>

<style lang="scss">
// Global style cho popper
.premium-user-popper {
  padding: 0 !important;
  border-radius: 20px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 34, 102, 0.15) !important;
  overflow: hidden;

  .user-card-header {
    padding: 25px 20px;
    text-align: center;
    background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
    border-bottom: 1px solid #f1f5f9;

    .avatar-big-wrapper {
      position: relative;
      width: 70px;
      margin: 0 auto 12px;
      .avatar-big {
        width: 70px;
        height: 70px;
        border-radius: 22px;
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
      }
      .status-indicator {
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: 14px;
        height: 14px;
        background: #10b981;
        border: 3px solid #fff;
        border-radius: 50%;
      }
    }

    .user-name-display {
      margin: 0;
      font-size: 16px;
      font-weight: 700;
      color: #1e293b;
    }
    .user-role-display {
      margin: 4px 0 0;
      font-size: 12px;
      color: #64748b;
    }
  }

  .user-card-body {
    padding: 10px;

    .menu-item-group {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: 15px;
      cursor: pointer;
      transition: all 0.2s;
      margin-bottom: 2px;

      &:hover {
        background: #f8fafc;
        .arrow-next { transform: translateX(3px); color: #409eff; }
      }

      .icon-box {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        i { color: #fff; font-size: 18px; }

        &.blue-gradient { background: linear-gradient(135deg, #60a5fa, #2563eb); }
        &.orange-gradient { background: linear-gradient(135deg, #fbbf24, #d97706); }
        &.purple-gradient { background: linear-gradient(135deg, #a78bfa, #7c3aed); }
      }

      .menu-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        .main-title { font-weight: 600; font-size: 14px; color: #334155; }
        .sub-title { font-size: 11px; color: #94a3b8; margin-top: 2px; }
      }

      .arrow-next { color: #cbd5e1; font-size: 14px; transition: all 0.3s; }
    }
  }

  .user-card-footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 15px;
    background: #f8fafc;

    .btn-flat {
      border: none;
      padding: 10px;
      border-radius: 12px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: all 0.2s;

      &.primary {
        background: #eff6ff;
        color: #2563eb;
        &:hover { background: #dbeafe; }
      }

      &.danger {
        background: #fef2f2;
        color: #dc2626;
        &:hover { background: #fee2e2; }
      }
    }
  }
}
</style>